export class FileUploadError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "FileUploadError";
    }
}
